import { computed } from 'vue';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { ObjectType } from '@/@types/graphql-types';
import { MaybeRefOrGetter, toValue } from '@vueuse/core';

const oldBuyboxCountries = ['AR', 'IN', 'IT'];

export function useBuyboxView({ titleObjectType }: { titleObjectType: MaybeRefOrGetter<ObjectType | undefined> }) {
	const { country } = useLanguageStore();

	const isMoviePage = computed(() => {
		return toValue(titleObjectType) === ObjectType.Movie;
	});

	// Currently, we show the old buybox in IT, IN, AR on movie pages. Logged in and out.

	const isBuyboxViewExpActive = computed(() => {
		const isBuyboxExpViewCountry = oldBuyboxCountries.includes(country.value);
		return isBuyboxExpViewCountry && isMoviePage.value;
	});

	return {
		isBuyboxViewExpActive,
	};
}
